import css from 'styled-jsx/css';

const style = css`
  .area-info {
    margin: 0 0 50px 0;
  }
  .button-wrapper {
    margin: 48px 24px;
  }
  .archive-area-button {
    margin-top: 15px;
    color: red;
    cursor: pointer;
  }
  .map-container {
    height: 300px;
    margin: 0 24px 16px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .collapse-container {
    margin: 40px 24px 40px 24px;
  }
  .opening-hours-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 0 16px 8px 16px;
  }
  .edit-button {
    cursor: pointer;
  }
  .markdown-wrapper :global(p) {
    margin: 0;
  }
`;

export default style;
